import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
    name: "checklist",
    standalone: false
})
export class ChecklistPipe implements PipeTransform {
  transform(value: any) {
    if (value === 1) {
      return "CHECK-IN";
    } else {
      return "CHECK-OUT";
    }
  }
}
